<div class="dl-dialog-backdrop" *ngIf="isOpen" (click)="!busy && cancel.emit()">
  <!--
    cdkTrapFocus keeps Tab inside the dialog; autoCapture moves focus into it on
    open and restores it to the trigger on close.
  -->
  <div
    class="dl-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="isOpen"
    (click)="$event.stopPropagation()">

    <h2 class="dl-dialog__title">{{ title }}</h2>
    <p class="dl-dialog__message" *ngIf="message">{{ message }}</p>

    <div class="dl-dialog__actions">
      <button
        type="button"
        class="dl-btn"
        [disabled]="busy"
        (click)="cancel.emit()">
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="dl-btn"
        [ngClass]="confirmClass"
        [disabled]="busy"
        (click)="confirm.emit()">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
